import { Box } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { appRequest } from "routes";
import UserTable from "./UserTable/UserTable";

export default function Users() {
  return (
    <Box>
      <UserTable />
    </Box>
  );
}
